import { axiosPrivate } from '../apis/Axios';
import { useEffect } from 'react';
import useRefreshToken from './useRefreshToken'
import useAuth from './useAuth';

const useAxiosPrivate = () => {
    const refresh = useRefreshToken();
    const { auth } = useAuth();

    useEffect(() => {
        const requestIntercept = axiosPrivate.interceptors.request.use(
            config => {
                return config;
            }, 
            (err) => Promise.reject(err)
        );

        const responseIntercept = axiosPrivate.interceptors.response.use(
            res => res,
            async(err) => {
                const prevRequest = err?.config;
                if (err?.response?.status === 401 && !prevRequest?.sent) {
                    prevRequest.sent = true;
                    await refresh();
                    return axiosPrivate(prevRequest);
                }
                return Promise.reject(err);
            }
        )
        
        return () => {
            axiosPrivate.interceptors.request.eject(requestIntercept);
            axiosPrivate.interceptors.response.eject(responseIntercept);
        }
    }, [auth, refresh])

    return axiosPrivate;
}

export default useAxiosPrivate;